<ps-ui-header
  (closeSurvey)="goToDashboard($event)"
  (openServiceAccountModal)="selectBuyer($event)"
></ps-ui-header>
<ps-ui-edit-suppliers
  [surveyId]="surveyId"
  [auth]="auth"
></ps-ui-edit-suppliers>
